<app-simple-modal [title]="edit?'Editar categoria':'Agregar categoria'" [max]="50" (close)="close.emit($event)">
	<div fields>
		<div class="form-group">
			<label for="name" class="form-label">Nombre:</label>
			<input type="text" id="name" name="name" [(ngModel)]="name" class="form-control">
		</div>
		<div class="form-group">
			<label for="company" class="form-label">Cuenta asociada <i class="fa fa-asterisk text-danger"></i></label>
			<div class="input-group">
				<app-input-autocomplete (inputMethod)="writeAccount()" (changeStatus)="selectAccount($event.filterElement)" [allBorderRadius]="true"
					[filterElements]="accounts.filterElements" [placeholder]="'Busca una cuenta'" [custom]="true"
					[inputs]="accounts">
					<ng-template #itemsTemplate let-filter>
						<!-- This is the content that will be projected -->
						<div items>
							<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
								{{filter.name}}</h5>
							<span class="text-muted" style="color: white !important;">
								<b>{{filter.displayId}}</b></span>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
	</div>
	<div buttons>
		<app-loading-button [object]="buttonSave" [logo]="true" [colorLoading]="'white'" (clicked)="createOrEdit()" [disabled]="!name || !accountId">
		</app-loading-button>
	</div>
</app-simple-modal>